module.exports = __webpack_public_path__ + "img/profilePic.e6db9a02.jpg";